// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import { sync } from 'vuex-router-sync'
import 'vuetify/dist/vuetify.min.css'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import store from '@/store/store'
import Gravatar from 'vue-gravatar'
import Croppa from 'vue-croppa'
import JsonExcel from 'vue-json-excel'
import VeeValidate from 'vee-validate'
import wysiwyg from 'vue-wysiwyg'
import VueLazyload from 'vue-lazyload'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import './registerServiceWorker'
import Vue2Filters from 'vue2-filters'
import VueSession from 'vue-session'
// import { inspect } from 'util'

Vue.component('downloadExcel', JsonExcel)

Vue.use(VueSession)
Vue.use(VueLodash, lodash)
Vue.use(Croppa)
Vue.use(Vue2Filters)

Vue.component('v-gravatar', Gravatar)

Vue.use(VeeValidate)
Vue.use(wysiwyg, {})

Vue.config.productionTip = false

Vue.use(Vuetify, {
  iconfont: 'mdi' || 'fa'
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/img/error.png',
  loading: '/static/img/loading.gif',
  attempt: 1
})

sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js